const defaultLocation = {
  center: [49.1233, 55.7879], // [lng, lat]
  zoom: 5,
}

const mapConstants = { defaultLocation }
export default mapConstants
